(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feed-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const videos = document.querySelectorAll('.feed-video');

    // Create an IntersectionObserver to track when videos enter/leave the viewport
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          const video = entry.target;

          // Check if the video is in view
          if (entry.isIntersecting) {
            video.play(); // Play the video when it comes into view
          } else {
            video.pause(); // Pause the video when it goes out of view
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of the video is in the viewport
      }
    );

    // Observe each video
    videos.forEach((video) => {
      observer.observe(video);
    });

    // Add event listener to pause other videos when one is playing
    // videos.forEach((video) => {
    //   video.addEventListener('play', () => {
    //     videos.forEach((v) => {
    //       if (v !== video) v.pause();
    //     });
    //   });
    // });

    // videos.forEach((video) => {
    //   video.addEventListener('play', () => {
    //     videos.forEach((v) => {
    //       if (v !== video) v.pause();
    //     });
    //   });
    // });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    console.log('✅ Register form validation and autofill prevention active');

    function getErrorEl(field) {
      let err = document.getElementById('error-' + field.id);
      if (!err) {
        err = document.createElement('div');
        err.className = 'field-error';
        err.id = 'error-' + field.id;
        err.style.color = '#d00';
        err.style.fontSize = '13px';
        err.style.marginTop = '4px';
        err.setAttribute('aria-live', 'polite');
        field.insertAdjacentElement('afterend', err);
      }
      return err;
    }

    function setError(field, msg) {
      const el = getErrorEl(field);
      el.textContent = msg;
      el.style.display = 'block';
      field.setAttribute('aria-invalid', 'true');
      return false;
    }

    function clearError(field) {
      const el = getErrorEl(field);
      el.textContent = '';
      el.style.display = 'none';
      field.removeAttribute('aria-invalid');
      return true;
    }

    function scrollToError(form) {
      const err = form.querySelector(".field-error[style*='block']");
      if (err) {
        const input = err.previousElementSibling;
        if (input) input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (input) input.focus();
      }
    }

    function validateName(field, fieldName) {
      const raw = field.value.trim();
      if (!raw) return setError(field, fieldName + ' is required.');
      if (/[^A-Za-z\s]/.test(raw)) return setError(field, 'Only letters are allowed.');
      if (/\s{2,}/.test(raw)) return setError(field, 'Too many spaces.');
      if (raw.length < 2) return setError(field, fieldName + ' must be at least 2 characters.');
      return clearError(field);
    }

    function validateEmail(field) {
      const raw = field.value.trim();
      if (!raw) return setError(field, 'Email is required.');
      const emailPattern = /^[A-Za-z0-9._%+\-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
      if (!emailPattern.test(raw)) return setError(field, 'Invalid email format.');
      return clearError(field);
    }

    function validatePassword(field) {
      const raw = field.value;
      if (!raw) return setError(field, 'Password is required.');
      if (/\s/.test(raw)) return setError(field, 'Password cannot contain spaces.');
      if (raw.length < 6) return setError(field, 'Password must be at least 6 characters.');
      return clearError(field);
    }

    const form = document.getElementById('create_customer');
    const fName = document.getElementById('RegisterForm-FirstName');
    const lName = document.getElementById('RegisterForm-LastName');
    const email = document.getElementById('RegisterForm-email');
    const pass = document.getElementById('RegisterForm-password');
    const submitBtn = form.querySelector('button[type="submit"]');

    // ---------- Autofill Prevention ----------
    setTimeout(() => {
      email.value = '';
      pass.value = '';
      email.setAttribute('autocomplete', 'new-email');
      pass.setAttribute('autocomplete', 'new-password');
      const fake = document.createElement('input');
      fake.type = 'text';
      fake.style.position = 'absolute';
      fake.style.opacity = '0';
      fake.style.height = '0';
      fake.autocomplete = 'off';
      form.prepend(fake);
      setTimeout(() => fake.remove(), 800);
    }, 150);

    // ---------- Password Restrictions ----------
    pass.addEventListener('input', () => {
      const newVal = pass.value.replace(/\s+/g, '');
      if (newVal !== pass.value) {
        pass.value = newVal;
        setError(pass, 'Spaces are not allowed in password.');
      } else clearError(pass);
    });

    pass.addEventListener('paste', function (e) {
      const text = (e.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(text)) {
        e.preventDefault();
        setError(pass, 'Spaces are not allowed in password.');
      }
    });

    function validateAll() {
      const v1 = validateName(fName, 'First Name');
      const v2 = validateName(lName, 'Last Name');
      const v3 = validateEmail(email);
      const v4 = validatePassword(pass);
      return v1 && v2 && v3 && v4;
    }

    submitBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (validateAll()) {
        form.requestSubmit();
      } else {
        scrollToError(form);
      }
    });

    [fName, lName, email, pass].forEach((field) => {
      field.addEventListener('blur', () => {
        if (field === email) validateEmail(field);
        else if (field === pass) validatePassword(field);
        else validateName(field, field.labels?.[0]?.textContent.replace('*', '').trim());
      });
      field.addEventListener('input', () => {
        if (field === email) validateEmail(field);
        else if (field === pass) validatePassword(field);
        else validateName(field, field.labels?.[0]?.textContent.replace('*', '').trim());
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
